import React from 'react';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

class Footer extends React.Component {
  render() {
      const {t} = this.props
    return (
      <footer className="footer">
        <div className="container-fluid">
          <div className="copyright pull-right">
                        ©
            {' '}
            {new Date().getFullYear()}
                        , made with
            {' '}
            <i className="fa fa-heart heart" />
            {' '}
                        by
            {' '}
            <a href="http://dakika.com.tr">
                            Dakika
            </a>
          </div>
        </div>
      </footer>

    );
  }
}

export default withNamespaces()(Footer);



// WEBPACK FOOTER //
// ./src/components/footer/index.js